import { useState } from 'react';
import { Dialog } from './Dialog';
import { Button, Textarea, Field } from '../ui';

interface Props {
  open: boolean;
  title: string;
  message: string;
  requireReason?: boolean;
  confirmLabel?: string;
  destructive?: boolean;
  onClose: () => void;
  onConfirm: (reason?: string) => void | Promise<void>;
}
export function ConfirmDialog({ open, title, message, requireReason, confirmLabel = 'Confirm', destructive, onClose, onConfirm }: Props) {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  async function run() {
    if (requireReason && !reason.trim()) return;
    setBusy(true);
    try {
      await onConfirm(reason.trim() || undefined);
      onClose();
      setReason('');
    } catch {
      // Keep the dialog open on failure so the action stays retryable
      // (the error itself is surfaced to the user via a toast).
    } finally {
      setBusy(false);
    }
  }
  return (
    <Dialog open={open} onClose={onClose} title={title} footer={
      <>
        <Button onClick={onClose} disabled={busy}>Cancel</Button>
        <Button tone={destructive ? 'danger' : 'ember'} onClick={run} disabled={busy || (requireReason && !reason.trim())}>
          {confirmLabel}
        </Button>
      </>
    }>
      <p style={{ fontFamily: 'var(--font-edit)', fontSize: 15, color: 'var(--ink-2)' }}>{message}</p>
      {requireReason && (
        <Field label="Reason (recorded in audit log)">
          <Textarea value={reason} onChange={e => setReason(e.target.value)} placeholder="Why?" />
        </Field>
      )}
    </Dialog>
  );
}
